module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAQAAACR313BAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfjARQLEwNKrNU9AAAASElEQVQY02NgoCkwxSfHzJDMIMJwHatkEIMVAwMDQx1DBFbJFhgTUwGSJKYCNElUBVgkEQpQJBnRFPAzfGRowu1TW2oGKQEAALvoDOKsq6+aAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTAxLTIwVDEwOjE5OjAzKzAxOjAw/gxlFAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wMS0yMFQxMDoxOTowMyswMTowMI9R3agAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/CollapseText/down-arrow.png
// module id = 2172
// module chunks = 0